import { render, staticRenderFns } from "./emissionsCarbon.vue?vue&type=template&id=6cde0eb1&scoped=true"
import script from "./emissionsCarbon.vue?vue&type=script&lang=js"
export * from "./emissionsCarbon.vue?vue&type=script&lang=js"
import style0 from "./emissionsCarbon.vue?vue&type=style&index=0&id=6cde0eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde0eb1",
  null
  
)

export default component.exports